import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import { colorTheme } from 'theme';
import { type Theme } from '@mui/material/styles';

const CustomDialog = styled(Dialog)(({ theme }: { theme: Theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface IDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  className: string;
  classes?: unknown;
  fullWidth: boolean;
  screenWidth?: string;
  PaperProps?: Record<string, unknown>;
}

export interface IDialogTitleProps {
  id?: string;
  children?: React.ReactNode;
  onClose: () => void;
  screenWidth?: string;
}

const DialogTitleBox = (props: IDialogTitleProps): JSX.Element => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme: Theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const DialogBox = (props: IDialogProps): JSX.Element => {
  const { children, title, onClose, open, screenWidth, PaperProps, fullWidth } =
    props;
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      maxWidth={screenWidth ?? 'md'}
      fullWidth={fullWidth}
      PaperProps={PaperProps}
    >
      <DialogTitleBox id="customized-dialog-title" onClose={onClose}>
        <Typography
          variant="h4"
          color={colors.gray[100]}
          fontWeight="bold"
          sx={{ mb: '5px' }}
        >
          {title}
        </Typography>
      </DialogTitleBox>
      <DialogContent dividers>{children}</DialogContent>
    </CustomDialog>
  );
};

export default DialogBox;
